<!--
 * @Description: 添加/修改协议版本
 * @Author: 钱磊
 * @Date: 2022-08-16 15:26:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-16 17:34:38
-->
<!--  -->
<template>
	<div class="filed-info-layout h100 mt20">
		<div class="common-top">
			<el-form :model="versionForm" label-width="130px" size="medium" ref="versionForm">
				<el-form-item label="协议名称：">
					{{ versionForm.sname }}
				</el-form-item>
				<el-form-item label="备注用途：">
					{{ versionForm.remark }}
				</el-form-item>
				<el-form-item label="协议版本：">
					<el-input v-model="versionForm.version" disabled></el-input>
				</el-form-item>
				<el-form-item label="内容：" required>
					<wang-editor v-model="versionForm.content" ref="wangEditor" height="100%" :maxLength="5000"></wang-editor>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" plain size="medium" @click="saveAgreeVersion" :loading="btnLoading">提交</el-button>
					<el-button type="info" plain size="medium" @click="goBack">取消</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
import * as API from 'api/modules/rulesManagement'
export default {
	data() {
		return {
			versionDetail: {},
			versionForm: {
				sname: '',
				remark: '',
				version: '',
				content: ''
			},
			btnLoading: false,
			dealId: ''
		}
	},
	props: {},
	mounted() {
		if (this.$getSessionItem('versionDetail')) {
			this.versionDetail = JSON.parse(this.$getSessionItem('versionDetail'))
		}
		if (this.$getSessionItem('leftRowId')) {
			this.dealId = JSON.parse(this.$getSessionItem('leftRowId'))
		}
		this.getVersion()
	},
	methods: {
		// 获取协议版本明细
		getVersion() {
			let param = {
				id: '',
				dealId: ''
			}
			if (this.routeQuery == 'add') {
				param.dealId = this.dealId
			} else {
				param.id = this.versionDetail.id
			}
			API.getVersion(param).then((res) => {
				if (res.operationCode == 1) {
					res.data.content = res.data.content ? res.data.content : ''
					this.versionForm = res.data
				}
			})
		},
		saveAgreeVersion() {
			this.btnLoading = true
			if (this.versionForm.content == '') {
				this.$message.warning('协议版本内容不能为空！')
			} else {
				let params = Object.assign({}, this.versionForm)
				API.saveVersion(params)
					.then((res) => {
						if (res.operationCode == 1) {
							this.$message.success('操作成功！')
							this.btnLoading = false
							setTimeout(() => {
								this.$router.push({
									path: '/agreement-rule'
								})
								this.$emit('close')
							}, 500)
						} else {
							this.$message.error(res.msg)
							this.btnLoading = false
						}
					})
					.catch((err) => {
						this.btnLoading = false
					})
			}
		},
		goBack() {
			setTimeout(() => {
				this.$router.push({
					path: '/agreement-rule'
				})
				this.$emit('close')
			}, 50)
		}
	},
	computed: {
		routeQuery() {
			return this.$route.query.type
		}
	}
}
</script>
<style scoped lang="less">
.content {
	/deep/.editor .ql-container {
		max-height: 500px !important;
		overflow: auto !important;
	}
}
</style>
